import { bind } from 'app/_decorators/bind.decorator';
import * as angular from 'angular';

export class ModelFilledValidator implements ng.IDirective {
    public require = 'ngModel';
    public restrict = 'A';
    public scope = false;
    private valueToCheck: any;

    public link: ng.IDirectiveLinkFn = (
        scope: ng.IScope,
        element: JQuery,
        attr: ng.IAttributes,
        ngModelCtrl: ng.INgModelController
    ) => {
        ngModelCtrl.$validators['pkpModelFilledValidator'] = this.validate;

        scope.$watch(
            () => {
                return scope.$eval(attr['valueToCheck']);
            },
            (newValue: any) => {
                this.valueToCheck = newValue;
                ngModelCtrl.$validate();
            },
            true
        );
    };

    @bind
    private validate(modelValue): boolean {
        console.log(modelValue);
        if (!this.valueToCheck) {
            return false;
        }
        return true;
    }
}

angular
    .module('app')
    .directive('pkpModelFilledValidator', () => new ModelFilledValidator());
